import React, { useEffect, useState } from 'react';
import api from 'api/api';
import auth from 'utils/auth';
import Loader from 'ui/Loader/Loader';
import NoBeneficiary from 'components/modules/Beneficiaries/NoBeneficiary/NoBeneficiary';
import BeneficiaryTable from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryTable';
import BeneficiaryRow from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryRow/BeneficiaryRow';
import BeneficiaryCol from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryCol/BeneficiaryCol';
import { INetwork } from 'components/modules/Beneficiaries/Beneficiaries.model';
import { IApiBeneficiaryMobileResponse, IBeneficiaryMobile } from './SingleMobileBen.model';
import EditMobileBen from './EditMobileBen';

enum States {
  browsing = 'browsing',
  editing = 'editing',
}

interface ISingleMobileBen {
  networks: INetwork[];
}

const SingleMobileBen = ({ networks }:ISingleMobileBen) => {
  const [loadingData, setLoadingData] = useState(false);
  const [data, setData] = useState<IBeneficiaryMobile[]>([]);
  const [editData, setEditData] = useState<IBeneficiaryMobile | null>(null);

  const [state, setState] = useState<States>(States.browsing);

  const fetchBeneficiaries = () => {
    setLoadingData(true);
    api
      .get(`/beneficiary/mobilemoney?loginId=${auth.data?.loginId || ''}`)
      .then((response: IApiBeneficiaryMobileResponse) => {
        setData(response.beneficiaries);
      })
      .catch(() => {
        setData([]);
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  useEffect(() => {
    fetchBeneficiaries();
  }, []);

  const openEditForm = (e: React.MouseEvent<HTMLDivElement>) => {
    setState(States.editing);
    const object = data.find(({ id }) => id === Number(e.currentTarget.id));
    if (object) {
      setEditData(object);
    }
  };

  const closeEditForm = () => {
    setState(States.browsing);
    fetchBeneficiaries();
  };

  if (state === States.editing && editData) {
    return <EditMobileBen data={editData} networks={networks} onClose={closeEditForm} />;
  }

  const renderTable = () => (
    <BeneficiaryTable>
      {data.map((beneficiary) => (
        <BeneficiaryRow onClick={openEditForm} id={String(beneficiary.id)} key={beneficiary.id}>
          <BeneficiaryCol label="Full Name" value={beneficiary.name} width="20%" minWidth="200px" />
          <BeneficiaryCol label="Network" value={beneficiary.networkCode} width="20%" minWidth="180px" />
          <BeneficiaryCol
            label="Beneficiary Wallet Number"
            value={beneficiary.phoneNumber}
            width="100%"
            minWidth="400px"
          />
        </BeneficiaryRow>
      ))}
    </BeneficiaryTable>
  );

  return (
    <>
      {loadingData && <Loader fullHeight />}
      {!loadingData && data.length === 0 && <NoBeneficiary />}
      {!loadingData && data.length > 0 && renderTable()}
    </>
  );
};

export default SingleMobileBen;
